















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { AuthRepository } from "../../api/repositories/AuthRepository";
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { extend, localize } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
extend('required', required);
import ru from 'vee-validate/dist/locale/ru.json';
import { getBackend } from '@service/router/getters';
localize('ru', ru);

@Component({
    components: { ValidationProvider, ValidationObserver }
})
export default class AuthComponent extends Vue {
    @Prop({required: true}) repository!: AuthRepository;

    username = '';
    password = '';
    wrongPassword = false;

    mounted() {
        this.$refs['username'] && (this.$refs['username'] as HTMLElement).focus();
    }

    async login(invalid: boolean) {
        this.wrongPassword = false;
        if (!invalid) {
            await this.$emit('beforeLogin')
            try {
                const session = await this.repository.login(this.username, this.password);
                session.backend = getBackend(this.$route.params.backend);
                this.$emit('loggedIn', session);
            } catch (e) {
                if (e.response && e.response.status == 401) {
                    this.wrongPassword = true;
                }
            }
        }
    }
}
